import { useState } from 'react';

import {
  WorkspaceSetupFormSettings,
  WorkspaceSetupMode,
  getEmptyWorkspaceSettings,
} from '~/scenes/MyWorkspace/components/WorkspaceToolbar/components/WorkspaceToolbarReadMode/components/WorkspaceSetupDialog';

type UseWorkspaceSetupDialogOutput = {
  dialogOpen: boolean;
  handleDialogOpen: (preset: WorkspaceSetupFormSettings) => void;
  handleDialogClose: () => void;
  handleDialogSubmit: () => void;
  formSettings: WorkspaceSetupFormSettings | undefined;
};

export const useWorkspaceSetupDialog = (): UseWorkspaceSetupDialogOutput => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [formSettings, setFormSettings] =
    useState<WorkspaceSetupFormSettings>();

  const handleDialogOpen = (preset: WorkspaceSetupFormSettings) => {
    if (preset.mode === WorkspaceSetupMode.Duplicate) {
      setFormSettings({
        ...preset,
      });
    } else {
      setFormSettings({
        ...preset,
        payload: getEmptyWorkspaceSettings(),
      });
    }
    setDialogOpen(true);
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleDialogSubmit = () => {
    setDialogOpen(false);
  };

  return {
    dialogOpen,
    handleDialogOpen,
    handleDialogClose,
    handleDialogSubmit,
    formSettings,
  };
};
